
window.$ && $(document).ready(function() {
  headerSearchMobile();
  shopRoomMethod ();
  instagramGalleryMethod();
  flashSaleMethod();
  jdgmCarouselArrow();
  cardGridColor();
  klarnaModal();
  mobileCollectionCard();
  imgNavTab();
  mediaGalleryMethod();
  mobilescroll();
  switchTabButtonToGoods();
  footerMenuMobile();
  $(document).on('click', ".apply-discount-btn", function(e) {
    e.preventDefault()
    applyDiscount($(this).parent('.cart-sidebar-discount').find("#discount-code-input").val());
  }).on('click', ".applied-discount-code .applied-discount-code-wrapper,#clear-discount-btn", function(e) {
    e.preventDefault();
    let current_code = $(this).attr('data');
    clearDiscount(current_code);
  });
  $(document).on('click', '.coupon-copy-btn', function(e) {
    copyMethod($(this).attr('data'));
    $(this).text('Copied');
  });
  getShippingRate();
})

function copyMethod (spu_no) {
    try {
         const newInput = document.createElement("input");
         newInput.value = spu_no;
         document.body.appendChild(newInput);
         newInput.select();
         document.execCommand("Copy");
         newInput.remove();
         showCustomModal();
     } catch (e) {
       console.log(e);
     }
}
function showCustomModal() {
    setTimeout(function () {
        hideCustomModal();
    }, 2000);
}
function hideCustomModal() {
   $('.ant-message').css('display', 'none');
   $('.coupon-copy-btn').text('Copy');
}
function cardGridColor() {
  const colorDom = $('.product-grid-container .grid__item .card__content .grid-product__colors');
  for(let i = 0; i < colorDom.length; i ++) {
    const linkColor = $(colorDom[i]).find('.product-variant-link');
    //linkColor.eq(0).addClass('product-variant-link-checked');
    if (linkColor.length == 1) {
      //linkColor.hide();
    }
  }
  $(document).on('click', '.product-grid-container .grid__item .card__content .grid-product__colors .product-variant-link', function(e) {
   //e.preventDefault();
   e.stopPropagation
   const variantImg = $(this).attr('data-variant_img');
   const variantImg1 = $(this).attr('data-variant_img2');
   const url1 = $(this).attr('data-variant_url');
   const  price = $(this).attr('data-price');
   const  comparePrice = $(this).attr('data-compare_at_price');
   const title = decodeURIComponent($(this).attr('data-title'));
   const title1 = decodeURIComponent($(this).attr('data-sub_title')) ;
   $(this).addClass('product-variant-link-checked').siblings().removeClass('product-variant-link-checked');
   const cardContent = $(this).parents('.card__content');
   const cardImage = cardContent.siblings('.card__inner');
   cardContent.find('.card__heading .full-unstyled-link').attr('href', url1).text(title1);
   cardContent.find('h2').text(title);
   cardContent.find('.price__regular .price-item').text(price);
   cardContent.find('.price__sale .price-item').text(price);
   cardContent.find('.price__sale  .price-item--regular').text(comparePrice);
   cardImage.find('.card__heading .full-unstyled-link').attr('href', url1).text(title1);
   cardImage.find('h2').text(title);
   cardImage.find('.motion-reduce-2').attr('src', variantImg);
   cardImage.find('.motion-reduce-2').attr('srcset', variantImg);
   cardImage.find('.motion-reduce-1').attr('alt', title);
   cardImage.find('.motion-reduce-1').attr('src', variantImg1);
   cardImage.find('.motion-reduce-1').attr('srcset', variantImg1);
   cardImage.find('.motion-reduce-2').attr('alt', title1);
   cardImage.find('.img-hover').attr('href', url1);
  })
}

function headerSearchMobile() {
  $(document).on('click', '.header .search-form-mobile .search-form-mobile-span', function() {
    $('.header__search details .header__icon--search').click();
  })
  $(document).on('click', '.header .header__icons  .search-modal__close-button, .header__icons .reset__button', function() {
      if ($(window).width() > 990) {
        const referrerData = document.referrer; // 上一次的地址
        if (referrerData.indexOf('search?q=') == -1) {
          window.location.href = referrerData;
        }
      }
  })
}

var myCarousel = null;
function shopRoomMethod () {
  if($('.section-shop-the-look').length <= 0) {
    return;
  }
  $(document).on('mouseover', '.shop_room_home', function() {
     $(window).width() > 990 && $(this).find('.slick-arrow').css('opacity', 0.7);
  })
  $(document).on('mouseleave', '.shop_room_home', function() {
     $(window).width() > 990 && $(this).find('.slick-arrow').css('opacity', 0);
  })
  $(document).on('mouseover', '.shop_room_home .shop_room_img', function() {
      $(this).find('.tag-circle').css('display', 'flex');
  })
  $(document).on('mouseleave', '.shop_room_home .shop_room_img', function() {
      //$(this).find('.tag-circle').hide();
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        if ($(this).index() === 0) {
            return
        }
        $(this).find('.tag-circle').hide();
        $(this).find('.product-sign-line').hide();
        $(this).find('.product-sign-info').hide();
      }
  })
  
  $(document).on('mouseover', '.shop_room_home .shop_room_img .tag-circle', function() {
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        $(this).siblings('.product-sign-line').show();
        $(this).addClass('light-tag-circle').siblings('.product-sign-info').css('display', 'flex');
      } else {
        $(this).addClass('light-tag-circle');
      }
  })
  
  $(document).on('mouseleave', '.shop_room_home .shop_room_img .new-product-sign', function() {
      const haveClass = $(this).parents('.shop_by_room').attr('class')
      if (haveClass.indexOf('shop_by_room_details') > -1) {
        $(this).find('.product-sign-line').hide();
        $(this).find('.product-sign-info').hide();
      }
      $(this).find('.tag-circle').removeClass('light-tag-circle');
  })
  
  $(document).on('click', '.shop_room_home .shop_room_img .tag-circle', function() {
       const parentDom = $(this).parents('.new-product-sign').attr('product_url')
       const url =  window.location.origin + parentDom
       window.location.href = url
       console.log(parentDom)
      //openDetailsContentTow($(this));
      //$('.image-list-slick-room-modal .room-good-list-btn').remove();
      //$('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.room-image-list-content .room-good-list .room-good-checkbox', function() {
      const curClass = $(this).attr('class');
      if (curClass.indexOf('checkbox-checked') > -1) {
          $(this).removeClass('checkbox-checked');
      } else {
          $(this).addClass('checkbox-checked');
      }
      const tagPriceArr = []
      const priceArr = []
      const productSign = $('.room-image-list-content .room-good-list .checkbox-checked').find('input');
      let buttonStr = ''
      for(let i =0; i<productSign.length; i++) {
        const productPrice =  $(productSign[i]).attr('value');
        const productOldPrice =  $(productSign[i]).attr('product_old_price');
        const product_variant_id =  $(productSign[i]).attr('product_variant_id');
        const num =  $(productSign[i]).attr('indexnum');
        if(productOldPrice == '' || productOldPrice == 0){
          tagPriceArr.push(productPrice);
        }else{
          tagPriceArr.push(productOldPrice);
        }
        priceArr.push(productPrice)
        buttonStr +='<input type="hidden" name="items['+ num +'][quantity]" value="1">'+'<input type="hidden" name="items['+ num +'][id]" value="'+product_variant_id+'">'
      }
      const discount = $('.image-list-slick-room-modal #discount_code_off').length > 0 ? $('.image-list-slick-room-modal #discount_code_off').attr('data') : $(".section-shop-the-look .coupon-info #discount_code_off").attr('data');
      const discountRate = discount ? 1 - (Number(discount)/100) : 1;//折扣率
      const couponInfo = $(".section-shop-the-look .coupon-info").prop('outerHTML');
      const couponInfo1 = couponInfo ? couponInfo : '';
      const priceTotal = sumMethod(priceArr);
      const tagPriceTotal = sumMethod(tagPriceArr);
      const tagPriceTotalNum = tagPriceTotal == 0 ? 1 : Number(tagPriceTotal);
      const savePrice = Number(tagPriceTotal) - Number(priceTotal);
      const priceRate = (Number(tagPriceTotal) - Number(priceTotal))/tagPriceTotalNum;
      const priceRatetoFixed = priceRate.toFixed(2)*100 + '%';
      let savePriceStr = 'Save '+Shopify.formatMoney(savePrice, window.money_format)+' ('+priceRatetoFixed+')';
      let itemStr = '( ' +productSign.length+ ' Items ) Subtotal:'
      const $listTotal = $('.room-image-list-content .room-good-list-total');
      let discountPriceTotalFormat = '';
      if (couponInfo1) { // 有优惠券
         const discountPriceTotal = sumDiscountMethod(priceArr,discountRate);
         discountPriceTotalFormat = Shopify.formatMoney(discountPriceTotal, window.money_format);//折扣后价格转美元
         const discountSavePrice = Number(tagPriceTotal) - Number(discountPriceTotal); //折扣后节省钱
         const discountPriceRate = (Number(tagPriceTotal) - Number(discountPriceTotal))/tagPriceTotalNum;
         const discountPriceRatetoFixed = (discountPriceRate*100).toFixed(0) + '%';
         savePriceStr = 'Save '+Shopify.formatMoney(discountSavePrice, window.money_format)+' ('+discountPriceRatetoFixed+')';
      }
      $listTotal.show();
      $('.room-image-list-content .room-good-list-btn').show();
      if (productSign.length < 2) { //只选中了一个
        itemStr = '( ' +productSign.length+ ' Item ) Subtotal:'
        if (productSign.length == 1) {
          $listTotal.find('.price-canpup-info').hide();
          $('.image-list-slick-room-modal .room-good-list-btn .roomGoodButton').text('Buy Now');
          $('.image-list-slick-room-modal .product-info-price .product-info-red-price').removeClass('discountPriceStyle');
        } else {
          $listTotal.hide();
          $('.room-image-list-content .room-good-list-btn').hide();
        } 
      } else {
         $listTotal.find('.price-canpup-info').show();
         $('.image-list-slick-room-modal .room-good-list-btn .roomGoodButton').text('Buy Together');
         $('.image-list-slick-room-modal .product-info-price .product-info-red-price').addClass('discountPriceStyle');
      }
      $listTotal.find('.product-info-red-price').text(Shopify.formatMoney(priceTotal, window.money_format));
      $listTotal.find('.product-info-tag-price').text(Shopify.formatMoney(tagPriceTotal, window.money_format));
      discountPriceTotalFormat && $listTotal.find('.price-canpup-info .product-info-red-price').text(discountPriceTotalFormat);
      $listTotal.find('.enj-product-price-save').text(savePriceStr);
      $listTotal.find('.room-good-list-total-item').text(itemStr);
      $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
      $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 0);
  })

  $(document).on('click', '.shop_room_home .addCar-icon-look', function() {
      const productSign = $(this).closest('.idea-image').find('.new-product-sign');
      const tagPriceArr = []
      const priceArr = []
      let curDom = ''
      let buttonStr = ''
      for(let i =0; i<productSign.length; i++) {
        const productPrice =  $(productSign[i]).attr('product_price');
        const productOldPrice =  $(productSign[i]).attr('product_old_price');
        const product_img =  $(productSign[i]).attr('product_img');
        const product_variant_id = $(productSign[i]).attr('product_variant_id'); 
        const product_url = $(productSign[i]).attr('product_url');
        if(productOldPrice == '' || productOldPrice == 0){
          tagPriceArr.push(productPrice);
        }else{
          tagPriceArr.push(productOldPrice);
        }
        priceArr.push(productPrice);
        curDom+='<div href="javascript:void(0)" class="home-card-list">'
                  +'<div class="home-card-top">'
                  + '<img src="'+product_img+'">'
                   + '<span class="room-good-checkbox checkbox-checked">'
                      +   '<input type="checkbox" value="'+productPrice+'" product_old_price="'+productOldPrice+'"  product_variant_id="'+product_variant_id+'" indexnum="'+i+'"  style="display: none;">'
                       +   '<span class="checkbox-inner"></span>'
                      +'</span>'
                  +'</div>'
                  +'<div class="product-info-price">'
                  + $(productSign[i]).find('.product-info-price').last().html()
                  +'</div>'
                  +'<a  href="'+product_url+'" target="_blank" class="room-modal-left-btn" title="Full Details">'
                  +  '<span>Full Details </span>' 
                  +'</a> '
              +'</div>'

         buttonStr +='<input type="hidden" name="items['+ i +'][quantity]" value="1">'+'<input type="hidden" name="items['+ i +'][id]" value="'+product_variant_id+'">'
      }
      const discount = $('.image-list-slick-room-modal #discount_code_off').length > 0 ? $('.image-list-slick-room-modal #discount_code_off').attr('data') : $(".section-shop-the-look .coupon-info #discount_code_off").attr('data');
      const discountRate = discount ? 1 - (Number(discount)/100) : 1;//折扣率
      const couponInfo = $(".section-shop-the-look .coupon-info").prop('outerHTML');
      const couponInfo1 = couponInfo ? couponInfo : '';
      const priceTotal = sumMethod(priceArr);
      const tagPriceTotal = sumMethod(tagPriceArr);
      const tagPriceTotalNum = tagPriceTotal == 0 ? 1 : Number(tagPriceTotal) 
      const savePrice = Number(tagPriceTotal) - Number(priceTotal)
      const priceRate = (Number(tagPriceTotal) - Number(priceTotal))/tagPriceTotalNum;
      const priceRatetoFixed = (priceRate*100).toFixed(0) + '%';
      const priceTotalFormat = Shopify.formatMoney(priceTotal, window.money_format);
      const tagPriceTotalFormat = Shopify.formatMoney(tagPriceTotal, window.money_format);
      let savePriceStr = 'Save '+Shopify.formatMoney(savePrice, window.money_format)+' ('+priceRatetoFixed+')';
      let discountHtml = ''
      let discountPriceClass = ''
      if (couponInfo1) { // 有优惠券
         const discountPriceTotal = sumDiscountMethod(priceArr,discountRate);
         const discountPriceTotalFormat = Shopify.formatMoney(discountPriceTotal, window.money_format);//折扣后价格转美元
         const discountSavePrice = Number(tagPriceTotal) - Number(discountPriceTotal); //折扣后节省钱
         const discountPriceRate = (Number(tagPriceTotal) - Number(discountPriceTotal))/tagPriceTotalNum;
         const discountPriceRatetoFixed = (discountPriceRate*100).toFixed(0) + '%';
         savePriceStr = 'Save '+Shopify.formatMoney(discountSavePrice, window.money_format)+' ('+discountPriceRatetoFixed+')';
         discountPriceClass = 'discountPriceStyle' // 有优惠券时加上class
         discountHtml = '<div class="price-canpup-info">'
                +'<div class="price-canpup-info-top">'
            	  +'<span> EXTRA <i>10</i>% OFF</span>'
            	+'</div>'
            	+'<div class="price-canpup-info-bottom" style="margin-top: 8px;">'
            	+	'<span class="product-info-red-price" style="font-size: 28px;">'+discountPriceTotalFormat+'</span>'
            	+'</div>'
              +'</div>';
      }
      $('.image-list-slick-room-modal .room-good-list-btn').remove();
      if (productSign.length > 0) {
          const donString = '<div class="room-good-list">'+curDom+'</div>'+couponInfo1
              +'<div style="display: flex;justify-content: center;">'
              +'<div class="room-good-list-total">'
              +'<div class="room-good-list-total-item"> ( '+ productSign.length +' Items ) Subtotal:</div>'
              +'<div class="product-info-price">'
                  +'<span class="product-info-red-price '+discountPriceClass+'"> '+priceTotalFormat+'</span>'
                  +'<span class="product-info-tag-price"> '+tagPriceTotalFormat+ '</span>'
              +'</div>'
              +discountHtml
              +'<span class="enj-product-price-save">'+savePriceStr+'</span>'
              +'</div>'
              +'</div>'
              //+'<div class="room-good-list-btn"><button class="roomGoodButton">Buy Together</button></div>'

            const donString1 = '<div class="room-good-list-btn">'
              +'<span class="roomGoodButton">Buy Together</span>'
              +'<span class="room-modal-cart" style="margin-top: 10px;"><button class="roomGoodButton1">Add To Cart</button></span>'
              +'</div>'
          openDetailsContent(donString);
          $('.image-list-slick-room-modal .room-modal-bottom-btns').before(donString1);
      }
      $(".image-list-slick-room-modal .image-list-room-modal-title").text('Shop This Idea');
      $(".image-list-slick-room-modal").addClass('room-modal-open');
      $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
      $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 0);
      if (productSign.length == 1) {
          $(".image-list-slick-room-modal").find('.room-good-list').css('justify-content', 'center');
      }
      const curWidth = $(".image-list-slick-room-modal .home-card-top").width();
      $(".room-image-list-content .room-good-list img").css('height', curWidth+'px');
      $(".image-list-slick-room-modal .coupon-info").removeClass('hide');
      $('body').addClass('cartover');
      $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.shop_by_room .shop_room_home .product-sign-info', function() {
      openDetailsContentTow($(this))
      $('.image-list-slick-room-modal .room-good-list-btn').remove();
      $('.image-list-slick-room-modal .room-modal-bottom-btns .roomGoodButton1').removeClass('viewCheckOut');
  })
  
  $(document).on('click', '.image-list-slick-room-modal .enj-add-to-cart-btn', function() {
      $(".image-list-slick-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
  })
  
  $(document).on('click', '.shop_by_room_home .filter_button .filter_button_item', function() {
      const idMobile =  $(this).parents('.filter-button-content').hasClass('filter-button-content-mobile');
      if (idMobile) {
        $(this).addClass('filter_button_item_active').siblings().removeClass('filter_button_item_active');
      } else {
        filterIndexPageItem($(this));
      }  
      let filterClass = $(this).attr("filter-class");
      myCarousel.slick('slickUnfilter');
      if(typeof($(this).attr("filter-class"))=="undefined"){
        myCarousel.slick('slickGoTo', 0, true);
      }else{
        myCarousel.slick('slickSetOption', {'centerMode': false}); //去掉中心模式
        myCarousel.slick('slickFilter', '.'+filterClass);
      }
  })
  
  $(document).on('click', '.image-list-slick-room-modal .room-image-list-content .roomGoodButton', function() {
    $('.image-list-slick-room-modal .enj-add-to-cart-btn').click();
  })
  
  $(document).on('click', '.image-list-slick-room-modal .slick-room-modal-mask-close', function() {
      $(".image-list-slick-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open')//.hide();
      $(".image-list-slick-room-modal .image-list-room-modal-title").text('Product Details');
      $('body').removeClass('cartover');
  })

  //Room Ideas集合页面过滤
  $(document).on('mouseover', '.filter_button .filter_button_item-div', function() {
      if (isHaveClassMethod($(this).parents('.filter_button'))) {
        return
      }
      $(this).find('.filter-content-ul').show()
      $(this).siblings().find('.filter-content-ul').hide();
  })
  
  $(document).on('mouseleave', '.filter_button .filter_button_item-div', function() {
      if (isHaveClassMethod($(this).parents('.filter_button'))) {
        return
      }
      $(this).find('.filter-content-ul').hide()
      $(this).siblings().find('.filter-content-ul').hide();
  })
  
  function isHaveClassMethod($dom) {
     return $dom.hasClass('filter_button_index') ? true : false;
  }
  $(document).on('click', '.shop_by_room_home .filter_button .filter_button_item-div .filter-content-ul-more', function() {
     const isNeedScroll = $(this).siblings('.filter-content-ul').hasClass('is_need_scroll_style')
     if (!isNeedScroll) {
       $(this).find('span').text('Hide');
       $(this).siblings('.filter-content-ul').addClass('is_need_scroll_style');
     } else {
       $(this).find('span').text('More');
       $(this).siblings('.filter-content-ul').removeClass('is_need_scroll_style');
     }
  })
  //Room Ideas集合首页
  function filterIndexPageItem($dom) {
    const isHiden = $dom.siblings('.filter-content-ul').is(":hidden");
    if (isHiden) {
        let heightSrcollPc = $(window).width() > 990 ? [340, 340, 340, 345] : [80, 80, 80, 80] // 与样式设置的显示滚动条的值相比较
        $dom.siblings('.filter-content-ul').show();
        $dom.addClass('filter_button_item_active');
        $dom.find('.filter-icon-bottom').addClass('filter-icon-bottom-up');
        $dom.parent().siblings().find('.filter-content-ul').hide();
        $dom.parent().siblings().find('.filter-icon-bottom').removeClass('filter-icon-bottom-up');
        $dom.parent().siblings().find('.filter_button_item').removeClass('filter_button_item_active');
        $dom.parent().siblings().find('.filter-content-ul-more').hide();
        $dom.find('.filter-content-ul-more').hide();
        const ulHeight = $dom.siblings('.filter-content-ul').height();
        const curIndex = $dom.parent().index();
        $dom.find('.filter-content-ul-more').hide();
        if (heightSrcollPc[curIndex] < ulHeight) {
           $dom.find('.filter-content-ul-more').show()
        } 
    } else {
        $dom.siblings().hide();
        $dom.find('.filter-icon-bottom').removeClass('filter-icon-bottom-up');
        $dom.removeClass('filter_button_item_active');
        $dom.find('.filter-content-ul-more').hide()
    }
  }

  //Room Ideas集合首页复选框方法
  $(document).on('click', '.filter_button_index .filter_button_item-div .filter-content-item', function() {
      const titleName = $(this).find('.filter-content-item-name').text();
      const btnName = $(this).parent().siblings().find('i').text();
      const filterClass =  $(this).find('.filter-content-item-name').attr('filter-class')
      const strName = btnName+': '+titleName;
      appendContentCommon($(this), filterClass, strName);
      //buttonStyle($(this).parent());
  })
  $(document).on('click', '.filter-result .filter-result-item', function() {
      const titleName = $(this).find('.filter-result-item-name').attr('titlename');
      $(this).remove();
      const resultIitemDom = $('.filter_button .filter-content-item .filter-content-item-name');
      const resultIitemDomMobile = $('.mobile-filter-room-modal .filter-room-modal-item .filter-content-item-name');
      filterContentCommon(resultIitemDom, titleName);
      filterContentCommon(resultIitemDomMobile, titleName);
      hideResultContent();
  })
  
  $(document).on('click', '.filter-result .clear-all', function() {
      $('.filter-result .filter-result-item').remove();
      $('.filter-result').hide();
      $('.filter_button .filter-content-item .filter-content-checkbox').removeClass('filter-checkbox-checked');
      $('.mobile-filter-room-modal .filter-room-modal-item .filter-content-checkbox').removeClass('filter-checkbox-checked');
      $('.filter_button .filter_button_item').removeClass('filter_button_item_active');
      getAllFilterResultClass();
  })
  
  $(document).on('click', '.filter_button .filter-button-content .filter-content-item', function() { // 复选框逻辑
      const curClass = $(this).find('.filter-content-checkbox').attr('class');
      const titleName = $(this).find('.filter-content-item-name').text();
      const btnName = $(this).parent().siblings().find('i').text();
      const filterClass =  $(this).find('.filter-content-item-name').attr('filter-class')
      const strName = btnName+': '+titleName;
      appendContentCommon($(this), filterClass, strName);
      buttonStyle($(this).parent());
      //hideResultContent();
  })
  // 移动端菜单
  $(document).on('click', '.mobile-room-image-list-content .filter_button_item-div .filter_button_item', function() { // 菜单收缩
      const isHiden = $(this).siblings().is(":hidden")
      if (isHiden) {
          $(this).siblings().show();
          $(this).find('.filter-icon-bottom').addClass('filter-icon-bottom-up');
      } else {
          $(this).siblings().hide();
          $(this).find('.filter-icon-bottom').removeClass('filter-icon-bottom-up');
      }
  })
  
  $(document).on('click', '.mobile-room-image-list-content .filter_button_item-div .mobile-filter-content-item', function() {
    const curClass = $(this).find('.filter-content-checkbox').attr('class');
    const titleName = $(this).find('.filter-content-item-name').text();
    const btnName = $(this).parent().siblings().find('span').text();
    const strName = btnName+': '+titleName;
    const filterClass =  $(this).find('.filter-content-item-name').attr('filter-class')
    const resultIitemDom = $('.filter_button .filter-content-item .filter-content-item-name')
    for(let i=0 ; i <resultIitemDom.length; i++){
        const curTitleName = $(resultIitemDom[i]).text();
        const checkedDom = $(resultIitemDom[i]).parents('.filter-content-ul').find('.filter-checkbox-checked');
        if (curTitleName == titleName) {
            if (curClass.indexOf('filter-checkbox-checked') > -1) { 
                $(resultIitemDom[i]).siblings().removeClass('filter-checkbox-checked');
            } else {
                $(resultIitemDom[i]).siblings().addClass('filter-checkbox-checked');
            }
        }
        buttonStyle($(resultIitemDom[i]).parents('.filter-content-ul'));
    }
    appendContentCommon($(this), filterClass, strName)
  })
  
  $(document).on('click', '.mobile-filter-room-modal .mobile-filter-room-modal-mask-close', function() {
      $(".mobile-filter-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
      $('.mobile-filter-room-modal .mobile-room-image-list-content .filter-content-ul').hide()
      $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.mobile-filter-room-modal .filter-room-modal-footer-btn', function() {
      $(".mobile-filter-room-modal").removeClass('room-modal-open').removeClass('room-modal-mask-open');
      $('.mobile-filter-room-modal .mobile-room-image-list-content .filter-content-ul').hide();
      $('body').removeClass('cartover');
  })

  $(document).on('touchend', '.shop_by_room_details .filter_button .filter_button_item', function() {
      //$(this).addClass('filter_button_item_active').siblings().removeClass('filter_button_item_active');
      const curClass = $('.mobile-filter-room-modal').attr('class')
      if ($(window).width() < 990 && curClass.indexOf('room-modal-open') == -1) {
          $('.mobile-filter-room-modal').addClass('room-modal-open');
          const textName = $(this).find('i').text()
          const resultIitemDom = $('.mobile-filter-room-modal .filter_button_item').find('span')
          for(let i=0 ; i <resultIitemDom.length; i++){
              const curTitleName = $(resultIitemDom[i]).text();
              if (curTitleName == textName) {
                  $(resultIitemDom[i]).parent().siblings().show();
              } 
          }
      }
  })

  let slidesToShow_temp = 1;
  let initialSlide_temp = 0;
  if($('.shop_by_room_home .shop_room_home .shop_room_img').length >1){
     slidesToShow_temp = 1.01;
     initialSlide_temp = 0;
  }
  
  myCarousel = $('.shop_by_room_home .shop_room_home').slick({
      slidesToShow: $(window).width() > 990 ? 1.5: 1,
      slidesToScroll: $(window).width() > 990 ? slidesToShow_temp : 1,
      dots: false,
      arrows: true,
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: $('.shop_room_home .shop_room_img').length == 1 ?  false : true,
      //prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      //nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      centerPadding: $(window).width() > 990 ? '0px': '0px',
      prevArrow:'<button type="button" class="prev-slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      nextArrow:'<button type="button" class="next-slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: false,
      lazyLoad:'ondemand',
      initialSlide: -1,
      rtl: true
  });
  const firstChild = $('.shop_by_room_home .filter_button .filter-button-content-pc .filter_button_item-div').eq(0);
  const firstItemChild = firstChild.find('.filter_button_item');
  firstItemChild.length>0 && filterIndexPageItem(firstItemChild); //搭配选中第一个
}

function openDetailsContentTow($dom) {
  let curDom = $dom.siblings('.product-sign-details-box').html();
  const content_infosale = $("#content_infosale_html").html();
  const product_handle = $dom.parent('.new-product-sign').attr('product_handle');
  const product_url = $dom.parent('.new-product-sign').attr('product_url');
  const product_variant_id = $dom.parent('.new-product-sign').attr('product_variant_id'); 
  let buttonStr ='<input type="hidden" name="items[0][quantity]" value="1">'+'<input type="hidden" name="items[0][id]" value="'+product_variant_id+'">'
  curDom += '<div class="room-modal-content-infosale list_ul_engo_full">'+content_infosale+'</div>'
      /*+'<div class="room-modal-bottom-btns">'
      +'<a  href="'+product_url+'" target="_blank" class="room-modal-left-btn">'
      +  '<span>Full Details </span>' 
      +'</a> '
      +'<div class="room-modal-add-cart-warp">'
      + '<button type="button" class="room-modal-cart-button">'
      +  '<span>Add To Cart</span>'
      + '</button>'
      +'</div>'
      +'</div>'*/
  openDetailsContent(curDom);
  const pre_sale_day_tmp = $dom.parent('.new-product-sign').attr('tags');
  const pre_sale_index = pre_sale_day_tmp.indexOf('PRE-SALE#');
  const discountcode_index = pre_sale_day_tmp.indexOf('DiscountCode');
  if(discountcode_index !== -1){
    var discountcode_str_tmp = pre_sale_day_tmp.substring(discountcode_index+12);
    const discountcode_index2 = discountcode_str_tmp.indexOf(',');
    if(discountcode_index2 !== -1){
      discountcode_str_tmp = discountcode_str_tmp.substring(0, discountcode_index2);
    }
    discountcode_str_arr = discountcode_str_tmp.split('---');
    $('.room-modal-content-infosale .free-sale-info, .room-modal-content-infosale .free-pre-sale-info').hide();
    if(discountcode_str_arr.length == 4){
      $('.room-modal-content-infosale .free-sale-info-day').html(discountcode_str_arr[3]).show();
      $('.room-modal-content-infosale .free-sale-info-code-off').html(discountcode_str_arr[2]);
      $('.room-modal-content-infosale .free-sale-info-code-name label').html(discountcode_str_arr[1]);
      $('.room-modal-content-infosale .coupon-copy-btn').attr('data',discountcode_str_arr[1]);
      if(discountcode_str_tmp.indexOf('PRE-SALE') === -1){
        $('.room-modal-content-infosale .free-sale-info').show(); 
      }
    }
  }else if(pre_sale_index !== -1){
    var goods_pre_sale_day_tmp = pre_sale_day_tmp.substring(pre_sale_index+9);
    const pre_sale_index2 = goods_pre_sale_day_tmp.indexOf(',');
    if(pre_sale_index2 !== -1){
      goods_pre_sale_day_tmp = pre_sale_day_tmp.substring(0, pre_sale_index2);
    }
    $('.room-modal-content-infosale .pre-sale-label, .free-pre-sale-info').show();
    $('.room-modal-content-infosale .free-sale-info').hide();
    $('.room-modal-content-infosale .free-pre-sale-info label').html(goods_pre_sale_day_tmp);
  }else{
    $('.room-modal-content-infosale .pre-sale-label, .free-pre-sale-info').hide();
    $('.room-modal-content-infosale .free-sale-info').show();
  }
  $(".image-list-slick-room-modal").addClass('room-modal-open');
  $('.image-list-slick-room-modal .room-modal-bottom-btns .room-modal-left-btn').attr('href', product_url );
  $('.image-list-slick-room-modal .room-modal-cart-div').empty().append(buttonStr);
  $('.image-list-slick-room-modal .room-modal-bottom-btns').css('opacity', 1);
  getPreviewBadgeByJudgeApi(product_handle, $('.image-list-slick-room-modal .room-modal-preview-badge'));
  const curWidth = $('.image-list-slick-room-modal .room-image-list-content').width();
  $('.image-list-slick-room-modal .room-image-list-content>img').css('height', curWidth+'px');
  $('body').addClass('cartover');
}

function openDetailsContent(dom) {
  $('.room-image-list-content').empty().append(dom);
}

function sumMethod(arr) { // 求和
  let total = 0;
  arr.forEach(v => {
      total += v ? Number(v) : 0;
  })
  return arr.length > 0 ? total : 0
}

function sumDiscountMethod(arr, rate) { // 求和
  let total = 0;
  arr.forEach(v => {
      total += v ? Math.ceil(Number(v)*rate) : 0;
  })
  return total
}

function buttonStyle($dom) {
    const checkDom = $dom.find('.filter-checkbox-checked');
    if (checkDom.length > 0) {
        $dom.siblings().addClass('filter_button_item_active');
    } else {
        $dom.siblings().removeClass('filter_button_item_active');
    }
}

function hideResultContent(dom) {
    const $dom = $('.filter-result .filter-result-item');
    if ($dom.length == 0) {
        $('.filter-result').hide();
    } else {
        $('.filter-result').show();
    }
   getAllFilterResultClass();
}

function addFilterContent(dom) {
  if ($(window).width() > 990) {
    $('.filter-result .clear-all').before(dom);
  } else {
    $('.filter-result .clear-all').after(dom);
  }
}

function filterContentCommon(resultIitemDom, titleName) {
    for(let i=0 ; i <resultIitemDom.length; i++){
        const curTitleName = $(resultIitemDom[i]).attr('filter-class');
        const checkedDom = $(resultIitemDom[i]).parents('.filter-content-ul').find('.filter-checkbox-checked');
        if (curTitleName == titleName) {
            $(resultIitemDom[i]).siblings().removeClass('filter-checkbox-checked');
        }
        buttonStyle($(resultIitemDom[i]).parents('.filter-content-ul'));
    }
}
function appendContentCommon($dom, titleName, strName) {
    const curClass = $dom.find('.filter-content-checkbox').attr('class');
    if (curClass.indexOf('filter-checkbox-checked') > -1) { // 取消选中
        $dom.find('.filter-content-checkbox').removeClass('filter-checkbox-checked');
        const resultIitemDom = $('.filter-result .filter-result-item .filter-result-item-name');
        for(let i=0 ; i <resultIitemDom.length; i ++){
            const curTitleName = $(resultIitemDom[i]).attr('titlename');
            if (curTitleName == titleName) {
                $(resultIitemDom[i]).parent().remove();
            }
        }
    } else {
        $dom.find('.filter-content-checkbox').addClass('filter-checkbox-checked');
        let domStr = '<div class="filter-result-item">'
                    +'<span class="filter-result-item-name" titlename="'+titleName+'">'+strName+'</span>'
                    +'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" width="14" height="14" fill="#212529" viewBox="0 0 298.667 298.667" style="enable-background:new 0 0 298.667 298.667;" xml:space="preserve">'
                        +'<g>'
                        +'<g>'
                        + '<polygon points="298.667,30.187 268.48,0 149.333,119.147 30.187,0 0,30.187 119.147,149.333 0,268.48 30.187,298.667     149.333,179.52 268.48,298.667 298.667,268.48 179.52,149.333"></polygon>'
                        +'</g>'
                        +'</g>'
                        +'</svg>'
                    +'</div>'
        addFilterContent(domStr)
    }
    const isTrue = $dom.parents('.filter_button').hasClass('filter_button_index'); // 首页不需要追加方法
    if (isTrue) {
      getAllFilterResultClassByIndex();
    } else {
      hideResultContent();
    }
}

/**首页多选框搜索**/
function getAllFilterResultClassByIndex() {
  let filterClass = getAllFilterResultClass('index') || [];
  if (filterClass.length == 0) {
    const allClass = $('.filter-button-content-pc a');
    let allClassArr = [];
    for (let i = 0; i< allClass.length; i ++) {
      const curClass = $(allClass[i]).attr('filter-class');
      allClassArr.push('.'+curClass)
    }
    filterClass = allClassArr
  }
  myCarousel.slick('slickSetOption', {'centerMode': false}); //去掉中心模式
  myCarousel.slick('slickUnfilter');
  myCarousel.slick('slickFilter', filterClass.join(','));
}

function getAllFilterResultClass(isIndexPage=''){
  const filterClassSelectedRoom = [];
  const filterClassSelectedStyle = [];
  const filterClassSelectedColor = [];
  const filterClassSelectedMaterial = [];
  const resultIitemDom = $('.filter-result .filter-result-item .filter-result-item-name');
  const allFilterClass = []
  for(let i=0 ; i <resultIitemDom.length; i++){
      const curTitleName = $(resultIitemDom[i]).attr('titlename');
      if(curTitleName.indexOf('_room_') !== -1){
        filterClassSelectedRoom.push(curTitleName);
      }else if(curTitleName.indexOf('_style_') !== -1){
        filterClassSelectedStyle.push(curTitleName);
      }else if(curTitleName.indexOf('_color_') !== -1){
        filterClassSelectedColor.push(curTitleName);
      }else if(curTitleName.indexOf('_material_') !== -1){
        filterClassSelectedMaterial.push(curTitleName);
      }
     allFilterClass.push('.'+curTitleName)
  }
  if (isIndexPage !== 'index') { //集合页才进入该方法
    addFilterShopRoomImg(filterClassSelectedRoom,filterClassSelectedStyle,filterClassSelectedColor,filterClassSelectedMaterial);
  }
  return allFilterClass;
  //addFilterShopRoomImg(filterClassSelectedRoom,filterClassSelectedStyle,filterClassSelectedColor,filterClassSelectedMaterial);
}

function checkDomHasClass($dom,arr){
  if(arr.length <= 0){
    return true;
  }
  for(var i=0; i<arr.length; i++){
    if($dom.hasClass(arr[i])){
      return true;
    }
  }
  return false;
}

function addFilterShopRoomImg(roomArr,styleArr,colorArr,materialArr){
  if(roomArr.length <= 0 && styleArr.length <= 0 && colorArr.length <= 0 && materialArr.length <= 0) {
    $('.shop_by_room .shop_room_img').show();
  }else{
    $('.shop_by_room .shop_room_img').hide();
    $('.shop_by_room .shop_room_img').each(function(){
      if(checkDomHasClass($(this),roomArr) && checkDomHasClass($(this),styleArr) && checkDomHasClass($(this),colorArr) && checkDomHasClass($(this),materialArr)){
          $(this).show();
      }
    });
  }
}

function ajaxGetSections(section_filename,ele_obj,callback){
  if (section_filename && ele_obj && callback) {
    $.ajax({
        url: '/?sections='+section_filename,
        type: 'GET',
        dataType: "json",
        cache: false,
        success: function(data) {
          callback(section_filename,ele_obj, data);
        },
        error: function(data) {
          console.log('section', data);
        }
    });
  }
}

function ajaxGetRecommendations(product_id,section_filename,limit,ele_obj,callback){
  if (section_filename && ele_obj && callback) {
    $.ajax({
        url: '/recommendations/products?product_id='+product_id+'&section_id='+section_filename+'&intent=related&limit='+limit,
        type: 'GET',
        dataType: "html",
        cache: false,
        success: function(data) {
          callback(ele_obj, data);
        },
        error: function(data) {
          console.log('section', data);
        }
    });
  }
}

function clearFilterResultMethod(){ // 集合页面筛选及清除功能
  $(document).on('click', '.collection-filter-result .filter-result-item', function(e) {
    const curClass = $(this).attr('class').trim();
    const splitClass = curClass.split(' ');
    let curClass1 = curClass
    if (splitClass.length > 1) {
      curClass1 = splitClass[1].trim()
    }
    const $dom =  $(window).width() > 990 ? $('.content-page .filter_sidebar_general .filter-tag') : $('.filter-to-left .filter_sidebar .filter-tag');
    $(this).remove();
    if (curClass1.indexOf('list-price') > -1) {
      window.filterPriceAjaxClick();
    } else {
      $dom.find('.'+curClass1).click();
    }
    e.stopPropagation();
  });
  $(document).on('click', '.collection-filter-result .clear-all, .mobile-clear-btns .clear-all', function(e) {
    const $dom =  $('.collection-filter-result');
    collectionFilter(e);
    $dom.find('.filter-result-item').remove();
    $dom.hide();
  });
  $(document).on('click', '.mobile-clear-btns .mobile-clear-right-btns', function(e) {
    $('.filter-to-left').removeClass('active');
    $('.bg-minicart').removeClass('active');
    $('.mobile-clear-btns').css('left', '-100%');
    $('body').removeClass('cartover');
  });
}


Shopify.formatMoney = function(cents, format) {
  var value = '',
  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
  formatString = (format || this.money_format);

  if (typeof cents == 'string') {
    cents = cents.replace('.','');
  }

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getPreviewBadgeByJudgeApi(product_handle, ele_obj) {
    if (product_handle && (typeof judge_api_authorize_params) != 'undefined' && judge_api_authorize_params) {
     try {
       jQuery.ajax({
           dataType: "json",
           url: 'https://judge.me/api/v1/widgets/preview_badge?'+judge_api_authorize_params+ '&handle=' + $.trim(product_handle),
           cache: false,
           success: function(data) {
               if(data && (typeof data.badge) != 'undefined' && data.badge && data.badge.indexOf('No reviews') === -1){
                  ele_obj.empty().html(data.badge);
               }else{
                  ele_obj.html('');
               }
           },
           error: function() {
  
           }
      });
    } catch (e) {
       console.log(e);
    }
  }
}

var slickDom = null;
function instagramGalleryMethod() { // 相册页面功能
    if($('.section-instagram-gallery').length <= 0) {
      return;
    }
    $(document).on('click', '.image-list-item', function() {
        let indexData = $(this).find('.img-box').attr('index');
        slickDom.slick('slickGoTo', Number(indexData)-1);
        const curDom = $('.image-list-slick-modal .image-list-item-video');
        for(let i = 0; i < curDom.length; i ++){
          curDom[i].addEventListener('pause', function() {
            $(curDom[i]).siblings('.video-icon').show();
          }, { passive: true });
          curDom[i].addEventListener('play', function() {
            $(curDom[i]).siblings('.video-icon').hide();
            const curDom1 = $('.image-list-slick-modal .image-list-item-video');
            for(let i = 0; i < curDom1.length; i ++){
              const curClass =  $(curDom1[i]).parent().attr('class')
              if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
               if (curClass.indexOf('slick-active') == 0){
                   $(curDom1[i])[0].pause()
               }
             }
            }
          }, { passive: true });
          curDom[i].addEventListener('ended', function() {
            $(curDom[i]).siblings('.video-icon').show();
          }, { passive: true });
        }
        setTimeout(function() {
          $('.image-list-slick-modal .video-icon').show();
          const modalWidth = $('.image-list-slick-modal').find('.slick-track').width();
          if ($(window).width()<990 && modalWidth < 50) {
            $('.image-list-slick-modal').find('.slick-track').css('width', $(window).width()+'px');
            $('.image-list-slick-modal').find('.img-box').css('width', $(window).width()+'px')
          }
          const badgeDom = $('.jdgm-badge-placeholder .jdgm-prev-badge')
          for (let i = 0 ; i < badgeDom.length; i ++) {
            $(badgeDom[i]).removeClass('jdgm--waiting-for-batch-done');
          }
        }, 800);
        $('body').addClass('cartover');
        $(".image-list-slick-modal").show();
    })
    $(document).on('click', '.slick-modal-mask-close', function() {
        $(".image-list-slick-modal").hide();
        $('body').removeClass('cartover');
        pauseVideo();
        
    })
    $(document).on('click', '.image-list-slick-modal .video-icon', function() {
      pauseVideo();
      const $domVideo = $(this).siblings('video');
      if ($domVideo && $domVideo.length > 0) {
        $domVideo[0].play();
        $(this).hide();
      }
    })
    $(document).on('click', '.section-instagram-gallery .next-slide', function(e) {
       pauseVideo();
       if (e && e.preventDefault){
           e.preventDefault();
       } else {
          window.event.returnValue = false;
       }
       if(e && e.stopPropagation){
          e.stopPropagation()
       }
       return false;
    })
    $(document).on('click', '.section-instagram-gallery .prev-slide', function(e) {
       pauseVideo();
       if (e && e.preventDefault){
           e.preventDefault();
       } else {
          window.event.returnValue = false;
       }
       if (e && e.stopPropagation){
         e.stopPropagation()
       }
       return false;
    })
    function pauseVideo() {
      const curDom = $('.image-list-slick-modal .image-list-item-video');
      for(let i = 0; i < curDom.length; i ++){
       if ($(curDom[i]) && $(curDom[i]).length > 0) {
         $(curDom[i])[0].pause()
       }
      }
    }
    slickDom =  $('.image-list-slick-modal .image-list-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: isAppleMobile() ?  false : true, 
      infinite: true,
      vertical: false,
      verticalSwiping: false,
      centerMode: false,
      centerPadding: 0,
      //prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      //nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      prevArrow:'<span class="prev-slide"><svg fill="none" width="16" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      nextArrow:'<span class="next-slide"><svg fill="none" width="16" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
      focusOnSelect: false,
      swipe: isAppleMobile() ?  false : true,
      //lazyLoad:'ondemand'
   })
    if ($(window).width() > 990) {
      $('.js_section_instagram_gallery .image-list').slick({
        slidesToShow:  $(window).width() > 990 ? 3 : 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        infinite: true,
        vertical: false,
        verticalSwiping: false,
        centerMode: false,
        centerPadding: 0,
        //prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
        //nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
        prevArrow:'<button type="button" class="prev-slide" aria-label="Previous Page"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
        nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
        focusOnSelect: false,
        initialSlide: 0
        //lazyLoad:'ondemand',
     })
    }

    const imageListLength = $(window).width() > 990 ? $('.js_section_instagram_gallery_index .image-list-pc .image-list-item-outer').length > 1 : $('.js_section_instagram_gallery_index .image-list-mobile .image-list-item-outer').length > 1
  
    if (imageListLength) {
      $('.js_section_instagram_gallery_index .image-list').slick({
          slidesToShow:  $(window).width() > 990 ? 1.01 : 1.03,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
          infinite: true,
          vertical: false,
          verticalSwiping: false,
          centerMode: true,
          centerPadding: $(window).width() > 990 ? 0 : '0px',
          //prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
          //nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
          prevArrow:'<button type="button" class="prev-slide" aria-label="Previous Page"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
          nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
          focusOnSelect: false,
          initialSlide: 0,
          adaptiveHeight: false
          //lazyLoad:'ondemand',
      })
    }
    slickDom.on("afterChange", function(e, slick, currentSlide){
       if (e && e.preventDefault){
           e.preventDefault();
       } else {
          window.event.returnValue = false;
       }
       if (e && e.stopPropagation){
         e.stopPropagation()
       }
    })
    // const height1 = $('.image-list-item').width();
    // $(".image-list-item .img-box img").css('height', height1+'px');
    // $(".image-list").css('opacity', 1);
    const height1 = $('.image-list-item').width() ? $('.image-list-item').width() : $(window).width()/2
    const isHaveClassDom = $('.section-instagram-gallery .js_section_instagram_gallery_index');
    if (isHaveClassDom.length > 0) {
       //$(".image-list-item .img-box img.image-list-item-img").css('height', (height1/2)+'px');
      const isPc = $(window).width() > 990 ? true : false;
       const imageDom = $(".image-list-item-outer");
       for(let i=0; i <imageDom.length; i ++) {
          const firstDom = $(imageDom[i]).children().eq(0); //第一个元素
          if (isPc){
           // firstDom.find('.img-box img.image-list-item-img').css('height', (height1+20)+'px');
          } else {
          //  firstDom.find('.img-box img.image-list-item-img').css('height', (height1+10)+'px');
          }
      }
    } else {
      $(".image-list-item .img-box img.image-list-item-img").css('height', height1+'px');
    }
    $(".image-list").css('opacity', 1);
    ajaxAddCartByForm('form.compare-form-cart');
}
// 是否为 iPhone
function isAppleMobile() {
  return (navigator.platform.indexOf('iPhone') != -1);
}

function flashSaleMethod() {
 
   $('.flash-sale-section .js-flash-sale .trans-product').length > 4 && $('.flash-sale-section .js-flash-sale').slick({
      slidesToShow: $(window).width() > 990 ? 4.01: 2.06,
      slidesToScroll: $(window).width() > 990 ? 4: 2,
      dots: $(window).width() > 990 ? true : false,
      arrows: true,
      infinite: false,
      vertical: false,
      verticalSwiping: false,
      centerMode: $('.flash-sale-section .js-flash-sale .js_size_prod').length == 1 ?  false : true,
      prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
      centerPadding: $(window).width() > 990 ? '0px': '0px',
      //prevArrow:'<button type="button" class="prev-slide" aria-label="Previous Page"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      //nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: false,
      lazyLoad:'ondemand',
      initialSlide: 0
  });
}

function jdgmCarouselArrow() {
  const container =  $('.jdgm-container .jdgm-carousel__arrows');
  const leftArrow = container.find('.jdgm-carousel__left-arrow');
  const rightArrow = container.find('.jdgm-carousel__right-arrow');
  const arrowDom1 = container.find('.jdgm-carousel__left-arrow .fa-arrow-left');
  const arrowDom2 = container.find('.jdgm-carousel__right-arrow .fa-arrow-right');
  arrowDom1.length==0 && leftArrow.append(`<svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
  arrowDom2.length==0 &&  rightArrow.append(`<svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
}
function instagramProductHandle() {
  if($('.instagram_product_handle .jdgm-badge-placeholder').length){
      var data;
      data = $.map($('.jdgm-badge-placeholder'), function(element) {
        var hash = {};
        var $element = $(element);
        hash['productHandle'] = $element.data('handle');
        hash['badgePlaceholder'] ='.jdgm-badge-placeholder[data-handle="' + $element.data('handle') + '"]'; return hash;
      });
      var checkBatchRenderBadges = setInterval( function(){
        if (typeof jdgm !== 'undefined' && typeof jdgm.batchRenderBadges === 'function') {
          jdgm.batchRenderBadges(data);
          clearInterval(checkBatchRenderBadges);
          console.log('batchRenderBadges ok');
        }else{
          console.log('batchRenderBadges error');
        }
      }, 100);
  }
  $('.instagram_product_handle').each(function() {
    var product_handle_str = $(this).attr('data');
    var v_index_of = product_handle_str.indexOf('?');
    if(v_index_of>0){
      product_handle_str = product_handle_str.substr(0,v_index_of);
    }
    var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
  });
}

function normalizeProductHandle(handle) {
  if (!handle) {
    return '';
  }
  var normalized = $.trim(handle);
  var query_index = normalized.indexOf('?');
  if (query_index > 0) {
    normalized = normalized.substr(0, query_index);
  }
  var variant_index = normalized.indexOf(':');
  if (variant_index > 0) {
    normalized = normalized.substr(0, variant_index);
  }
  normalized = normalized.replace(/^\/products\//, '');
  return normalized;
}

function getProductInfo(product_handle, ele_obj, callback) {
  product_handle = normalizeProductHandle(product_handle);
  if (product_handle) {
      try{
        jQuery.ajax({
            dataType: "json",
            //url: "/products/" + $.trim(product_handle) + ".js",
            url: "/products/" + product_handle + ".js",
            cache: false,
            success: function(data) {
                callback && callback(ele_obj, data);
            },
            error: function() {

            }
        });
      } catch (e) {
       console.log(e);
      }
    }
}
function getInstagramProductInfo(ele_obj, product_info){
    if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
      if(product_info.variants.length > 0){
        let show_variant_index = 0;
        for(variants_i=0; variants_i<product_info.variants.length; variants_i++){
            if(product_info.variants[variants_i].available){
              show_variant_index = variants_i;
              break;
            }
        }
        let show_current_handle = $(ele_obj).attr('data');
        for(variants_i=0; variants_i<product_info.variants.length; variants_i++){
            if(product_info.variants[variants_i].available && show_current_handle.indexOf(product_info.variants[variants_i].id) != -1){
              show_variant_index = variants_i;
              break;
            }
        }
        $(ele_obj).find('input[name="id"]').val(product_info.variants[show_variant_index].id);
        $(ele_obj).find('input[name="product-id"]').val(product_info.id);
        $(ele_obj).find('.engoj_find_right_title').html(product_info.variants[show_variant_index].name);
        $(ele_obj).find('a').attr('href', product_info.url).attr('title',product_info.title);
        $(ele_obj).find('img.img-responsive').attr('src',product_info.featured_image+'&width=200').attr('title',product_info.title).attr('alt',product_info.featured_image.alt);
        if(product_info.compare_at_price == null){
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
        }else{
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
            $(ele_obj).find('s.price-old').html(Shopify.formatMoney(product_info.compare_at_price, window.money_format));
        }
      }
    }

    if(ele_obj && ele_obj.length && product_info && product_info.variants.length >=1){
        $(ele_obj).attr('product_id', product_info.id).attr('variant_id',product_info.variants[0].id);
    }
}
function getInstagramProductInfo2(ele_obj, product_info){
    if(ele_obj && ele_obj.length && product_info && product_info.variants.length >=1){
        $(ele_obj).attr('product_id', product_info.id).attr('variant_id',product_info.variants[0].id);
    }
}
function ajaxAddCartByForm(form_selector){
    $(form_selector).on('submit', function(event) {
      const productId = $(this).find('.product-product-id').val()
      const variantId = $(this).find('.product-variant-id').val();
      if (!productId || !variantId) {
        const productId1 =   $(this).parent().parent().attr('product_id');
        const variantId2 = $(this).parent().parent().attr('variant_id');
        $(this).find('.product-product-id').val(productId1);
        $(this).find('.product-variant-id').val(variantId2);
      }
      event.preventDefault(); // prevent default form submission
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: function(line_item) {
          console.log(12, line_item);
          let mycart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if((typeof line_item) != 'undefined'){
            mycart.renderContents(line_item);
            if (mycart && mycart.classList.contains('is-empty')) mycart.classList.remove('is-empty');
          }
        },
        error: function(data) {
          console.log(22, data);
        }
      });
    });
}
function getProductnstagram(section_filename,ele_obj,data){
    var product_handle_contain = 0;
    var related_product_new = $('#product_spu_title');
    var related_product_handle = related_product_new.attr('product_handle');
    var related_product_handle_arr = related_product_handle.split(',');
    let $res_html = $(data[section_filename]);
    let current_product_sku_ele = $('#current-product-all-sku');
    $res_html.find('.instagram_product_handle').each(function() {
      var product_handle_spu = $(this).attr('spuattr');
      if(product_handle_spu != ''){
        if(current_product_sku_ele.hasClass(product_handle_spu)){
          product_handle_contain = 1;
          let product_handle_string = $(this).attr('product_handle');
          $(this).attr('data', current_product_sku_ele.html()).attr('product_url', "/products/"+current_product_sku_ele.html()); 
          $res_html.find('div[ product_handle="'+product_handle_string+'"]').attr('product_handle', product_handle_string+'|'+current_product_sku_ele.html());
        }
      }else{
        if(typeof data[section_filename] != 'undefined' && data[section_filename]){
            for(var i=0; i<related_product_handle_arr.length; i++){
                if(data[section_filename].indexOf('/'+related_product_handle_arr[i]) !== -1){
                  product_handle_contain = 1;
                }
            }
        }
      }
    });
    
    //ele_obj.before($res_html);
    if(product_handle_contain == 1){
      var img_box_index = 0;
      $res_html.find('.image-list .image-list-item').each(function(){
        let item_product_handle = $(this).attr('product_handle');
        let item_product_handle_show = 0;
        for(var i=0; i<related_product_handle_arr.length; i++){
          if(item_product_handle.indexOf(related_product_handle_arr[i]) !== -1){
            item_product_handle_show = 1;
          }
        }
        if(item_product_handle_show == 0){
            $res_html.find($(this)).remove();
        }else{
          $(this).find('.img-box').attr('index', ++img_box_index);
        }
      });
      img_box_index = 0;
      $res_html.find('.image-list-slick .img-box').each(function(){
          let item_product_handle = $(this).attr('product_handle');
          let item_product_handle_show = 0;
          for(var i=0; i<related_product_handle_arr.length; i++){
            if(item_product_handle.indexOf(related_product_handle_arr[i]) !== -1){
              item_product_handle_show = 1;
            }
          }
          if(item_product_handle_show == 0){
              $res_html.find($(this)).remove();
          }else{
            $(this).attr('index', ++img_box_index);
          }
      });
      ele_obj.before($res_html);
      //ele_obj.after($res_html);
      if($('.instagram_product_handle').length>0){
        $('.section-instagram-gallery .instagram_gallery_title').html('Find #Aogllati In Media');
        instagramProductHandle();
        instagramGalleryMethod();
      }
    }
  }
jQuery(document).ready(function($) {
  $('.instagram_product_handle2').each(function() {
    var product_handle_str = $(this).attr('data');
    var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo2);
  });
  $('.instagram_product_handle').each(function() {
    var product_handle_str = $(this).attr('data');
    var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
  });
  ajaxAddCartByForm('form.compare-form-cart');
  ajaxAddCartByForm('form.compare-form-cart-item');
  $('.addCar-icon').on('click', function(e) {
    let c_product_id = $(this).attr('product_id');
    let c_variant_id = $(this).attr('variant_id');
    if(c_product_id && c_variant_id){
      $('form.compare-form-cart .product-product-id').val(c_product_id);
      $('form.compare-form-cart .product-variant-id').val(c_variant_id);
      $('form.compare-form-cart').submit();
    }
    e.stopPropagation();
  });
  setTimeout(function () {
    instagramProductHandle();
  }, 2500);
  if($('.product-section').length){
    setTimeout(function () {
      ajaxGetSections('template--21542532317372__instagram_gallery_page_FPWxdn',  $('.shopify-app-block[id*=judge_me_reviews_review_widget]').parents('.shopify-section'),getProductnstagram);
    }, 2500);
  }
  if($('.shopify-section--judge-reviews-carousel').length){
    $('.jdgm-carousel__left-arrow').html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>');
    $('.jdgm-carousel__right-arrow').html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg>');
    $('.jdgm-carousel-item__review-wrapper').each(function(){
      let item_reviewer_name = $(this).find('.jdgm-carousel-item__reviewer-name');
      $(this).find('.jdgm-carousel-item__review-rating').before(item_reviewer_name);
      //item_reviewer_name.remove();
      $(this).after($(this).find('.jdgm-carousel-item__reviewer-name-wrapper'));
      $(this).find('.jdgm-carousel-item__reviewer-name-wrapper').remove();
    });
    $('.jdgm-carousel-item__product.jdgm-ellipsis').each(function(){
      $(this).attr('href',$(this).attr('href').replace('#judgeme_product_reviews',''));
      let product_handle_str = $(this).attr('href');
      product_handle_str = product_handle_str.replace('/products/','');
      getProductInfo(product_handle_str,$(this),showProductThumbnail)
    });
  }
});
function klarnaModal() {
  $(document).on('click', '.klarna-message-model .klarna-message-model-payment-close', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.klarna-message-model .payment-close-span', function(e) {
    $('.klarna-message-model').css('display', 'none');
    $('body').removeClass('cartover');
  })
  
  $(document).on('click', '.klarna-message-block-view .klarna-message-link', function(e) {
    $('.klarna-message-model').css('display', 'flex').css('width', $(window).width()).css('height', $(window).height());
    $('body').addClass('cartover');
  })
}

function slickObject(dom, pcNum=1, mobileNum=1, optionField= {} ) {
  dom.slick({
    slidesToShow: $(window).width() > 990 ? pcNum : mobileNum,
    slidesToScroll: 1,
    dots: false,
    arrows:  true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '3px',
    prevArrow: '<button type="button" class="prev-slide" aria-label="Previous Page"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="Next Page"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    focusOnSelect: false,
    ...optionField
  })
  return dom
}
function mobileCollectionCard() {
  const option = {
    dots: true,
    arrows: false,
    infinite: false,
    centerMode: false,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
  }
  const cardMedia = $('#ProductGridContainer .grid__item .card__media .img-hover');
  for(let i = 0; i < cardMedia.length; i++){
    $(window).width()<990 && slickObject($(cardMedia[i]),1,1,option)
  }
}

function menuScrollMethod(navLi) {
  //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
  //const navLi = isHave ? $('.section-float-nav-new .row .section-float-nav-ul li') : $('.section-float-nav .row .section-float-nav-ul li');
  let arr = [];
  for (let i = 0; i < navLi.length; i ++) {
    const idName =  $(navLi[i]).find('a').attr('href');
    const heightData = $(idName).length > 0 && movingDistance($(idName));
    arr.push({
      id: idName,
      left: $(navLi[i]).length > 0 ? parseInt($(navLi[i])[0].getBoundingClientRect().left) : 0,
      range: heightData ? heightData.positionRange : [0, 0],
      top: heightData ? heightData.top : 0
    })
    if ($(window).width() > 990) {
      $(idName).on('mouseenter', function() {
         const curTop = parseInt($(idName)[0].getBoundingClientRect().top)
         const haveData = arr.filter(v => v.id == idName);
         const indexN = arr.findIndex(v => v.id == idName);
         const topValue1 = haveData.length > 0 ?  parseInt(haveData[0].top) : 0;
         if (topValue1 == curTop) { // 当前页面是否在滚动
           return
         }
         if (indexN > -1) {
            arr[indexN].top = curTop
         }
         const str = 'a[href="'+idName+'"]';
         const dom = navLi.find(str).parent();
         const curIndex = dom.index();
         dom.addClass('li-active').siblings().removeClass('li-active');
         if (curIndex > 4 || curIndex < 3){
           curIndex > 4  && $('.section-float-nav .section-float-nav-ul .next-slide').click();
           curIndex < 3 && $('.section-float-nav .section-float-nav-ul .prev-slide').click();
         }
      })
    } else {
      $(document).on('touchstart', idName, function() {
         const str = 'a[href="'+idName+'"]';
         const dom = navLi.find(str).parent();
         const curIndex = dom.index();
         const checkChildDom = dom.length > 0 ? dom[0].getBoundingClientRect().left : 0;
         dom.addClass('li-active').siblings().removeClass('li-active');
         let scrollWidth = parseInt(document.querySelector('.row .section-float-nav-ul').scrollLeft) ; // 滚动的宽度+元素与窗口的距离
         debounce(moveToNavItem('.row .section-float-nav-ul', checkChildDom+scrollWidth+20), 5);
         //const haveData = arr.filter(v => v.id == idName);
         //const leftValue1 = haveData.length > 0 ? haveData[0].left : checkChildDom;
         //moveToNavItem('.row .section-float-nav-ul', checkChildDom ? checkChildDom.left : 0 )
      })
      if ($("#bundle-product-view-id").length == 0) {
        $(navLi[i]).find('a[href="#bundle-product-view-id"]').parent().hide()
      }
    }
  }
}

function movingDistance($dom) {
  if ($dom && $dom.length == 0) { return };
  let idNameDom =  $dom.length > 0 ? $dom[0].getBoundingClientRect() : null;
  let idNameDomTop = idNameDom ? parseInt(idNameDom.top) : 0 ;
  let idNameDomLeft = idNameDom ? parseInt(idNameDom.left) : 0 ;
  let idNameDomBottom = idNameDom ? parseInt(idNameDom.bottom) : 0 ;
  let idNameDomHeight = idNameDom ? parseInt(idNameDom.height) : 0 ;
  let scrollHeigth = parseInt(document.documentElement.scrollTop) ||  parseInt(window.scrollY) ; // 滚动的高度+元素与窗口的距离
  let idNameRange = [idNameDomTop+scrollHeigth, idNameDomTop+idNameDomHeight+scrollHeigth]; // 元素位置所处的范围
  return {
    top: idNameDomTop, // 离body的距离
    height: idNameDomHeight, // 元素的高度
    scrollHeigth: scrollHeigth, // 滚动的高度
    positionRange: idNameRange,  // 元素位置的范围
    left: idNameDomLeft, 
    bottom: idNameDomBottom
  }
}

function moveToNavItem(className, leftValue=0, top=0) {
  document.querySelector(className).scrollTo({
    top: top,
    left: leftValue ,
    behavior: "smooth",
  })
}

function debounce(fn, delay) { // 节流函数，频繁操作只执行一次
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

function switchTabButtonToGoods() { // 切换按钮到对应的商品菜单
   setTimeout(function(){ 
    $('.section-float-nav .row .section-float-nav-ul li').length > 0 && menuScrollMethod($('.section-float-nav .row .section-float-nav-ul li'));
    $('.section-float-nav-new .row .section-float-nav-ul li').length > 0 && menuScrollMethod($('.section-float-nav-new .row .section-float-nav-ul li'));
    if ($('.section-float-nav-new-v2 .row .section-float-nav-ul li').length > 0) {
      menuScrollMethod($('.section-float-nav-new-v2 .section-float-nav-ul li'));
      $('.section-float-nav-new-v2 .container-v2').css('visibility', 'visible');
      //const isHidden = $('.menu_moblie .header_top_bar_block').is(':hidden');
      //$(window).width() < 990 && $(".section-float-nav-new-v2").css('top', isHidden ? '53px' : '97px');
    }
  }, 500) 
   $(document).on('click', '.row .section-float-nav-ul li', function(e) {
     const curIndex = $(this).index();
     const idName = $(this).find('a').attr('href');
     const heightData = $(idName).length > 0 && movingDistance($(idName));
     const parentsClass = $(this).parents('div[data-section-type]').attr('data-section-type');
     $(this).addClass('li-active').siblings().removeClass('li-active');
     let scollHeight = 75
     if ($(window).width() < 990) { // M端
       const navDom = $('.mobile-model-nav .section-float-nav-ul li');
       navDom.removeClass('li-active');
       navDom.eq(curIndex).addClass('li-active');
       scollHeight = 97
     } else { // pc
       scollHeight = 20
     }
     const mobileDom = $('.mobile-model-nav');
     const isHiden = mobileDom.is(":hidden");
     if (!isHiden) {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
     }
     let fixBarHeight = 75
     if (parentsClass == 'section-float-nav-new') {
      fixBarHeight = parseInt($('.section-float-nav-new').height())+90 
     } else if (parentsClass == 'section-float-nav-new-v2') {
      fixBarHeight = parseInt($('.section-float-nav-new-v2').height())+scollHeight
     } else if (parentsClass == 'section-float-nav') {
      fixBarHeight = parseInt($('.section-float-nav').height())+75
     }
     //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
     //const fixBarHeight = isHave ? parseInt($('.section-float-nav-new').height())+90 : parseInt($('.section-float-nav').height())+75;
     $(idName).css('scroll-margin-top', fixBarHeight+'px');
     e.preventDefault();
     const curScrollTop = heightData ? heightData.scrollHeigth : 0;
     const idNameDomTop = heightData ? heightData.top : 0;
     document.documentElement.scrollTop = parseInt(idNameDomTop+curScrollTop-fixBarHeight);
  })

  $(document).on('click', '.mobile-model-nav .section-float-nav-ul li', function(e) { // m端下拉点击菜单
     if ($(window).width() < 990) {
      const curIndex = $(this).index();
      const liDom = $('.row .section-float-nav-ul li');
      const idName = $(this).find('a').attr('href');
      const heightData = $(idName).length > 0 && movingDistance($(idName));
      const parentsClass = $(this).parents('div[data-section-type]').attr('data-section-type');
      $(this).addClass('li-active').siblings().removeClass('li-active');
      liDom.removeClass('li-active');
      liDom.eq(curIndex).addClass('li-active');
      $('.mobile-model-nav').hide();
      $('.row .mobile-down-btn').removeClass('up-style').addClass('down-style');
      const childDom = document.querySelector('.row .section-float-nav-ul').children;
      const checkChildDom = childDom.length > 0 ? childDom[curIndex].getBoundingClientRect() : null;
      const scrollWidth = parseInt(document.querySelector('.row .section-float-nav-ul').scrollLeft) ; // 滚动的高度+元素与窗口的距离
      const leftWidth = checkChildDom ? checkChildDom.left : 0 ;
      moveToNavItem('.row .section-float-nav-ul', scrollWidth+leftWidth ); // 菜单滚动条
      let fixBarHeight = 75
      if (parentsClass == 'section-float-nav-new') {
        fixBarHeight = parseInt($('.section-float-nav-new').height())+90 
      } else if(parentsClass == 'section-float-nav-new-v2') {
        fixBarHeight = parseInt($('.section-float-nav-new-v2').height())+100
      } else if(parentsClass == 'section-float-nav') {
        fixBarHeight = parseInt($('.section-float-nav').height())+75
      }
      //const fixBarHeight = parseInt($('.section-float-nav').height())+75;
      $(idName).css('scroll-margin-top', fixBarHeight+'px');
      e.preventDefault();
      const curScrollTop = heightData ? heightData.scrollHeigth : 0;
      const idNameDomTop = heightData ? heightData.top : 0;
      document.documentElement.scrollTop = parseInt(idNameDomTop+curScrollTop-fixBarHeight);
    }
  })
  
  $(document).on('click', '.row .mobile-down-btn', function(e) {
    const isHiden = $('.mobile-model-nav').is(":hidden");
    const mobileDom = $('.mobile-model-nav');
    if (isHiden) {
      mobileDom.show();
      $(this).removeClass('down-style').addClass('up-style');
    } else {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
    }
  })
  if ($(window).width() > 990) {
    $('.section-float-nav .section-float-nav-ul').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows:  true,
      infinite: false,
      vertical: false,
      verticalSwiping: true,
      prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: true,
    })
  }
}

function imgNavTab() {
  const option ={
    arrows: false,
    infinite: false,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
  }
  const slickDom = slickObject($('.img-nav-tab-section .img-nav-tab-content'), 1, 1, option)
  $('.img-nav-tab-section .img-nav-tab-content').css('opacity', 1)
  $(document).on('click', '.img-nav-tab-section .img-nav-tab-menu li', function(e) {
    const num =  $(this).index()
    $(this).addClass('nav-li-active').siblings().removeClass('nav-li-active')
    slickDom.slick('slickGoTo', Number(num));
  })
  slickDom.on("afterChange", function(e, slick, currentSlide){
    $('.img-nav-tab-section .img-nav-tab-menu li').eq(currentSlide).addClass('nav-li-active').siblings().removeClass('nav-li-active')
  })
}

function mediaGalleryMethod() {
  const option ={
    arrows: $(window).width() > 990 ? true : false,
    infinite: false,
    dots: true,
    touchMove:$(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  }
  const option1 = {
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>'
  }
  const option3 ={
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  }
  const slickDom1 = slickObject($('.slide-products .js-slide-product'), 4, 1, option)
  const slickDom = slickObject($('.media-gallery .js-media-gallery'), 4, 1, option3)
  $('.slide-products .js-slide-product').css('opacity', 1)
  $(window).width()< 990 && slickObject($('.media-gallery-v2 .js-media-gallery-v2'), 1, 1, option1)
}

function mobilescroll() {
  const headerHeight = $('.header-wrapper').height(); // header
  const imgHeight = $('.section-image-banner').height() || 0; //banner图
  const mHeight = $(window).width() < 990 ? 110 : 150;
  const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new'); // float-nav-new组件
  const curHeight = isHave ? parseInt($('#overview-product-view-id').height()) - 100 : parseInt(imgHeight) - mHeight;
  const $nav = parseInt(headerHeight);
  scrollNavMethod(curHeight, $nav, $(this));
  let lastScrollTop = 0;
  $(document).scroll(function() {
    const currentScrollTop = $(this).scrollTop();
    // if ($(window).width() < 990) {
    //   if (currentScrollTop > lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '22px');
    //   } else if (currentScrollTop < lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '0px');
    //   }
    // }
    lastScrollTop = currentScrollTop;
    scrollNavMethod(curHeight, $nav, $(this))
  });
}

function scrollNavMethod(curHeight, navHeight, dom) {
    console.log('curHeight:'+curHeight+'navHeight:'+navHeight)
    if($(window).width() < 990) { // 移动端菜单设置
    const isHideBar = window.localStorage.getItem('hideHeaderBar');
    if (dom.scrollTop() > navHeight) { //滚动值大于主菜单栏
      //const heightData = isHideBar == 1 ? '53px' : '97px';
        $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '0px');
    } else {
        $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '38px');
    }

    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2').css('visibility', 'visible');
      isHideBar == 1 ?  $("div[id*='countdown_inzatB']").addClass('floatNavBottom') : $("div[id*='countdown_inzatB']").addClass('floatNavBottom floatNavBottom1')
    }else{
        $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2').css('visibility', 'hidden');
      $("div[id*='countdown_inzatB']").removeClass('floatNavBottom floatNavBottom1');
    }
  } else {
    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('z-index', '3');
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2').css('visibility', 'visible');
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '38px');
    }else{
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2').css('visibility', 'hidden');
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('z-index', '-1');
    }
  }
}

function footerMenuMobile() {
  if ($(window).width() < 990) {
    $('.footer .footer-block .footer-block__details-content').hide();
    const testName = $('.footer .footer-block .footer-block__heading span');
    for (let i = 0 ; i < testName.length; i ++) {
      if ($(testName[i]).text() == 'Support') {
        $(testName[i]).parents('.footer-block__heading').siblings('.footer-block__details-content').show();
        $(testName[i]).parents('.footer-block__heading').addClass('open');
      }
    }
  }
  $(document).on('click', '.footer h3.footer-block__heading', function(e) {
    if($(window).width() < 990 ) {
      const isHava =  $(this).hasClass('open');
      if(!isHava) {
        $(this).addClass('open').siblings('.footer-block__details-content').show();
      } else {
        $(this).removeClass('open').siblings('.footer-block__details-content').hide();
      }
    }
  })
  const productDom = $(".product .product__info-wrapper .product__accordion summary h2.accordion__title");
  for(let i = 0; i < productDom.length; i ++) {
    const textName = $(productDom[i]).text();
    if (textName.indexOf('Dimensions & Specifications') > -1) {
        $(productDom[i]).parents('details').find('.descriptionOuterBox').show();
        $(productDom[i]).parents('details').find('.accordion__content').css('max-height', '600px');
    }
    if (textName.indexOf('Quick Know') > -1) {
      $(productDom[i]).parents('summary').click();
    }
  }
}

function showTotalData(data, flag){
  const moneyFormat = getSafeMoneyFormat();
  const shippingFee = Number(window.shipping_fee) || 0;
  if(data.items.length<=0){
    return;
  }
  if(data.total_discount > 0) {
    var code_list = [];
    if(data.cart_level_discount_applications.length>0){
      data.cart_level_discount_applications.forEach(i => {
        if((typeof i.discount_application) != 'undefined'){
          code_list.push(i.discount_application.title.toUpperCase());
        }else if((typeof i.title) != 'undefined'){
          code_list.push(i.title.toUpperCase());
        }
      });
    }else if(data.discount_codes.length>0){
      data.discount_codes.forEach(i => {
        if(i.applicable == true){
          if((typeof i.code) != 'undefined'){
            code_list.push(i.code.toUpperCase());
          }else if((typeof i.title) != 'undefined'){
            code_list.push(i.title.toUpperCase());
          }
        }
      });
    }
    var code_html = "";
    code_list.forEach(item_c => {
      code_html += '<span class="applied-discount-code-wrapper" style="display: inline-flex;" data="'+item_c+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" aria-hidden="true"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg><span class="applied-discount-code-value" data="'+item_c+'">'+item_c+'</span><a href="javascript:void(0);" id="clear-discount-btn" data="'+item_c+'">X</a></span>';
    });
    $(".applied-discount-code").html(code_html);
    $(".applied-discount-code2").removeClass('hide');
    $(".cart-items-subtotal").html(Shopify.formatMoney(data.items_subtotal_price, moneyFormat));
    $(".cart-items-discount").html("-" + Shopify.formatMoney(data.total_discount, moneyFormat));
    let cart_total = data.total_price + shippingFee;
    $(".cart_total_money").html(Shopify.formatMoney(data.total_price, moneyFormat));
  } else {
    $(".applied-discount-code").html("");
    $(".applied-discount-code2").addClass('hide');
    if(flag){
      $(".discount-code-error").html("Please Enter Valid Coupon Code.");
    }
    $(".cart-items-subtotal").html(Shopify.formatMoney(data.items_subtotal_price, moneyFormat));
    $(".cart-items-discount").html("-" + Shopify.formatMoney(data.total_discount, moneyFormat));
    let cart_total = data.total_price + shippingFee;
    $(".cart_total_money").html(Shopify.formatMoney(cart_total, moneyFormat));
  }
  try{
        if($('#cart-items-discount-save-price').length > 0) {
          var cart_items_discount_save_price = parseInt($.trim($('#cart-items-discount-save-price').attr('value')));
          if(cart_items_discount_save_price > 0) {
            data.total_discount = data.total_discount + cart_items_discount_save_price;
          }
        }
    } catch (e) {
      console.log(e);
    }
    if($(".cart_total_savings").length>0){
      if(data.total_discount > 0){
        $(".cart_total_savings").html("Savings: " + Shopify.formatMoney(data.total_discount, moneyFormat));
        $(".cart_total_savings").removeClass('hide');
      }else{
        $(".cart_total_savings").addClass('hide');
      }
    }
}
function getShippingRate(){
  const moneyFormat = getSafeMoneyFormat();
  fetch('/cart/shipping_rates.json', {
      method: 'POST',
      body: JSON.stringify({
        shipping_address: {
          zip: "SW1A 1AA",
          country: "United Kingdom",
          province: "England"
        }
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(function(parsedState) {
      if (parsedState && parsedState.shipping_rates && parsedState.shipping_rates.length > 0 && parsedState.shipping_rates[0].price >= 0) {
        window.shipping_fee = parsedState.shipping_rates[0].price * 100;
        const shippingFee = Number(window.shipping_fee) || 0;
        var cart_shipping_fee_money = document.querySelectorAll('.cart_shipping_fee_money');
        for (var i = 0; i < cart_shipping_fee_money.length; i++) { 
          cart_shipping_fee_money[i].innerHTML = Shopify.formatMoney(shippingFee, moneyFormat);
          cart_shipping_fee_money[i].style='opacity: 1';
        }
        let cart_total = 0;
        if($('.template-cart').length>0){
          cart_total = parseInt($('.cart__footer .cart_total_money').attr('data-price')) + shippingFee;
        }else{
          cart_total = parseInt($('.cart_total_money').attr('data-price')) + shippingFee;
        }
        $('.cart_total_money').html(Shopify.formatMoney(cart_total, moneyFormat));
      }
    })
    .catch(e => console.error(e));
}
function clearDiscount(current_code) {
  $(".discount-code-error").html("");
  $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
    if($(this).attr('data') == current_code){
      $(this).remove();
    }
  });
  var code_arr = [];
  $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
    code_arr.push($(this).attr('data'));
  });
  if(code_arr.length>0){
    var code_temp = code_arr.join(",");
  }else{
    var code_temp = "none"
  }
  $(".enj-minicart-ajax .total-info-order .cart-items-subtotal").html("");
  $(".enj-minicart-ajax .total-info-order .cart-items-discount").html("");
  $(".enj-minicart-ajax .prod").addClass("noDiscount");
  /*fetch("/discount/CLEAR").then(function(data){*/
  fetch("/checkout?discount="+code_temp).then(function(data){
    fetch('/cart.js', {})
      .then(function(res){return res.json();})
      .then(function(data){
        showTotalData(data,0);
      })
  })
}
function applyDiscount(code) {
  if($.trim(code).length <= 0){
      return;
  }
  code = code.toUpperCase();
  var code_arr = [];
  $(".applied-discount-code .applied-discount-code-wrapper").each(function(){
    code_arr.push($(this).attr('data'));
  });
  if(code_arr.indexOf(code) !== -1){
      return;
  }
  code_arr.push(code);
  var code_temp = code_arr.join(",");
  $(".discount-code-error").html("");
  $(".apply-discount-btn").addClass('btn--loading').html("Apply <div class='loader'></div>");
  $(".apply-discount-btn").css("pointerEvents", "none");
  /*fetch(`/discount/${code_temp}`)*/
  fetch("/checkout?discount="+code_temp)
  .then(function() {
    // After the discount code has been applied, force the cart to update so the discount is visible
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {},
      }),
    }).then(function(res){
      return res.json();
    }).then(function(data) {
      showTotalData(data,1);
      $(".apply-discount-btn").html("Apply");
    })
  })
  .then(function() {
    // 更新购物车显示（如果需要）
    console.log('Please Enter Valid Coupon Code.');
  })
  .catch(function(error) {
    console.error('Error--:', error);
  }).finally(function(params) {
    $(".apply-discount-btn").removeClass('btn--loading').html("Apply");
    $(".apply-discount-btn").css("pointer-events",'all')
  });
}
/* judge reviews */
function showProductThumbnail(ele_obj, product_info){
    if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
      let img_html_str = '<img src="'+product_info.featured_image+'&width=60'+'" alt="" title="" class="judge-reviews-carousel-product-img" loading="lazy">';
      $(ele_obj).find('.jdgm-carousel-item__product-title').before(img_html_str).css('cssText', 'display: block !important');
    }
}

function getSafeMoneyFormat() {
  if (window.settings_new && window.settings_new.moneyFormat) {
    return window.settings_new.moneyFormat;
  }
  if (window.money_format) {
    return window.money_format;
  }
  return '£{{amount}}';
}